import { TieringConfig } from '@trimble/types';

export interface IconContextMenuSelectEvent {
  event: Event;
  value: string | undefined;
  menuItem: string;
}
export interface IconContextMenuSettings
  extends Partial<IconContextMenuOptions> {
  onSelection?(event: IconContextMenuSelectEvent): void;
}

export interface IconContextMenuOptions {
  name: string;
  iconSize: 'sm' | 'md' | 'lg';
  menuPlacement: 'bottom' | 'right' | 'left';
  tabAligned?: boolean;
  menuItems: IconMenuItem[];
  iconName: string;
  value?: string;
}

export interface IconMenuItem {
  label: string;
  value: string;
  accessConfig?: TieringConfig; // could consolidate feature flagging and user role access here
  disabled?: boolean;
  disabledReasonTooltip?: string;
}

export const ICON_CONTEXT_MENU_DEFAULTS: IconContextMenuOptions = {
  name: '',
  iconSize: 'md',
  menuPlacement: 'bottom',
  tabAligned: false,
  menuItems: [],
  iconName: 'more_vertical',
  value: undefined,
};
